"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactPopperTooltip = _interopRequireDefault(require("react-popper-tooltip"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Popover = require("./Popover.style");

var _Overlay = _interopRequireDefault(require("../overlay/Overlay"));

var _excluded = ["children", "content", "offset", "arrow", "width", "overlay", "modifiers", "onOverlayClick", "overflow", "open", "className", "zIndex"],
    _excluded2 = ["children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var Popover = function Popover(_ref) {
  var children = _ref.children,
      content = _ref.content,
      offset = _ref.offset,
      arrow = _ref.arrow,
      width = _ref.width,
      overlay = _ref.overlay,
      modifiers = _ref.modifiers,
      onOverlayClick = _ref.onOverlayClick,
      overflow = _ref.overflow,
      open = _ref.open,
      className = _ref.className,
      zIndex = _ref.zIndex,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_reactPopperTooltip["default"], (0, _extends2["default"])({}, props, {
    tooltipShown: Boolean(open) || undefined,
    modifiers: _objectSpread({
      name: 'offset',
      enabled: true,
      options: {
        offset: offset || [0, 10]
      }
    }, modifiers),
    tooltip: function tooltip(_ref2) {
      var _getTooltipProps;

      var arrowRef = _ref2.arrowRef,
          tooltipRef = _ref2.tooltipRef,
          getArrowProps = _ref2.getArrowProps,
          getTooltipProps = _ref2.getTooltipProps,
          placement = _ref2.placement;
      return /*#__PURE__*/_react["default"].createElement(_Popover.StyledPopover, (0, _extends2["default"])({}, getTooltipProps((_getTooltipProps = {
        ref: tooltipRef
      }, (0, _defineProperty2["default"])(_getTooltipProps, 'data-popper-placement', placement), (0, _defineProperty2["default"])(_getTooltipProps, "width", width), _getTooltipProps)), {
        className: (0, _classnames["default"])('eui-popover', className),
        overflow: overflow,
        zIndex: zIndex
      }), arrow && /*#__PURE__*/_react["default"].createElement("div", getArrowProps({
        'ref': arrowRef,
        'className': 'popover-arrow',
        'data-placement': placement
      })), content, overlay && /*#__PURE__*/_react["default"].createElement(_Overlay["default"], {
        onClick: function onClick() {
          if (typeof onOverlayClick === 'function') {
            onOverlayClick();
          }
        },
        zIndex: zIndex - 1
      }));
    }
  }), function (_ref3) {
    var getTriggerProps = _ref3.getTriggerProps,
        triggerRef = _ref3.triggerRef;
    return /*#__PURE__*/_react["default"].createElement("span", getTriggerProps({
      ref: triggerRef,
      className: 'trigger'
    }), children);
  });
};

Popover.defaultProps = {
  trigger: 'click',
  placement: 'bottom-end',
  offset: [0, 10],
  overlay: false,
  overflow: false,
  open: false,
  zIndex: 1500
};
Popover.propTypes = {
  children: _propTypes["default"].node,
  content: _propTypes["default"].node,
  offset: _propTypes["default"].array,
  width: _propTypes["default"].number,
  arrow: _propTypes["default"].bool,
  onVisibilityChange: _propTypes["default"].func,
  overlay: _propTypes["default"].bool,
  onOverlayClick: _propTypes["default"].func,
  modifiers: _propTypes["default"].object,
  placement: _propTypes["default"].oneOf(['top', 'top-start', 'top-end', 'right', 'right-start', 'right-end', 'bottom', 'bottom-start', 'bottom-end', 'left', 'left-start', 'left-end']),
  overflow: _propTypes["default"].bool,
  open: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  zIndex: _propTypes["default"].number
};

Popover.Options = function (_ref4) {
  var children = _ref4.children,
      props = (0, _objectWithoutProperties2["default"])(_ref4, _excluded2);
  return /*#__PURE__*/_react["default"].createElement(_Popover.StyledOptions, props, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('eui-option-inner', {
      active: props.active
    })
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _classnames["default"])('eui-option-child', {
      single: !Array.isArray(children)
    })
  }, children)));
};

Popover.Options.propTypes = {
  children: _propTypes["default"].node,
  disabled: _propTypes["default"].bool,
  isDelete: _propTypes["default"].bool,
  active: _propTypes["default"].bool
};
var _default = Popover;
exports["default"] = _default;